import DisplayTimeFrame from '@components/DisplayTimeFrame/DisplayTimeFrame';
import React from 'react';
import DisplaySelectedUnitTimeFrameProps
	from '@components/SchedulePage/DisplaySelectedUnitTimeFrame/DisplaySelectedUnitTimeFrameProps';
import { useFacilitySelection } from '@components/SchedulePage/utilities/useFacilitySelection/useFacilitySelection';

const DisplaySelectedUnitTimeFrame: React.FC<DisplaySelectedUnitTimeFrameProps> = ({ timeFrame, ...typographyProps }) => {
	const { selectedFacility } = useFacilitySelection();

	const timeZone = selectedFacility?.hospitalTimeZone;

	if (!timeZone) { return null; }

	return <DisplayTimeFrame timeFrame={timeFrame} timeZone={timeZone} {...typographyProps} />;
};

export default DisplaySelectedUnitTimeFrame;
